import { ConfigTypeEnum } from "../../types"
import { httpPost } from "../remoteDataProvider"

export async function uploadConfig(
  association: string,
  configType: ConfigTypeEnum,
  config: Record<string, any>,
  token: string,
) {
  try {
    const payload = { config }
    const response = await httpPost("people_flow_core", `/config/${association}/${configType}`, payload, token)
    return response
  } catch (error: any) {
    if (error.response.data.message) {
      throw { message: error.response.data.message }
    }
    throw error
  }
}
